import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Layout, HomePage } from './modules';
import { ProductosPage, CategoriasPage, ProductFormPage } from './modules/productos';
import { ProveedoresAdminPage } from './modules/proveedores/pages/ProveedoresAdminPage';
import { ClientesPage, ClientesListPage, ClienteFormPage } from './modules/clientes';
import { DetalleCotizacion, CentroCotizacionesPage, BorradoresRedirect, resolverDestinoDetalle } from './modules/cotizaciones';
import { ComprobanteEgreso } from './modules/contabilidad/pages/ComprobanteEgreso';
import { MovimientosEgreso } from './modules/contabilidad/pages/MovimientosEgreso';
import UXTestPage from './pages/UXTestPage';
import { theme } from './modules/shared/theme/theme';
import { CatalogoPage, MatchingPage } from './modules/catalogo';
import { AuthProvider } from './modules/auth/context/AuthContext';
import { LoginGate } from './modules/auth/components/LoginGate';

function AppRoutes() {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    // El ítem "Crear" del menú lateral (path '/cotizaciones/nueva') SIEMPRE aterriza en el
    // Detalle de Cotización y abre el pop-up de Nueva Bolsa (abrirCrear=true). Si no hay
    // ninguna bolsa, aterriza igual en el Detalle en su estado vacío — nunca en Centro ni
    // en Catálogo. Contrato fijo en resolverDestinoDetalle (ver resolverDestinoCrear.ts).
    if (path === '/cotizaciones/nueva') {
      resolverDestinoDetalle({ abrirCrear: true }).then((destino) => {
        navigate(destino.path, destino.state ? { state: destino.state } : undefined);
      });
      return;
    }
    navigate(path);
  };

  return (
    <Layout onNavigate={handleNavigation}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/productos/listar" element={<ProductosPage />} />
        <Route path="/productos/nuevo" element={<ProductFormPage />} />
        <Route path="/productos/crear" element={<ProductosPage />} />
        <Route path="/productos/editar" element={<ProductosPage />} />
        <Route path="/productos/categorias" element={<CategoriasPage />} />
        <Route path="/proveedores/admin" element={<ProveedoresAdminPage />} />
        <Route path="/clientes" element={<ClientesPage />} />
        <Route path="/cotizaciones" element={<CentroCotizacionesPage />} />
        {/* Detalle sin :bolsaId — aterrizaje de "Bolsas"/"Crear" cuando no hay ninguna
            bolsa: el Detalle se renderiza en su estado vacío (nunca cae a Centro/Catálogo). */}
        <Route path="/cotizaciones/detalle" element={<DetalleCotizacion />} />
        <Route path="/cotizaciones/detalle/:bolsaId" element={<DetalleCotizacion />} />
        <Route path="/cotizaciones/borradores" element={<BorradoresRedirect />} />
        <Route path="/contabilidad/comprobante-egreso" element={<ComprobanteEgreso onNavigate={handleNavigation} />} />
        <Route path="/contabilidad/informe-bancario" element={<ComprobanteEgreso onNavigate={handleNavigation} />} />
        <Route path="/contabilidad/movimientos-egreso" element={<MovimientosEgreso onNavigate={handleNavigation} />} />
        <Route path="/catalogo" element={<CatalogoPage />} />
        <Route path="/catalogo/matching" element={<MatchingPage />} />
        <Route path="/ux-test" element={<UXTestPage />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <LoginGate>
            <AppRoutes />
          </LoginGate>
        </ThemeProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;
